import React from 'react';
import './index.scss';

const PaymentProcess = () => {

    return (
        <div className='payment-process-wrapper position-fixed text-center d-flex align-items-center justify-content-center'>
            <div className="inner">
                <div className="head d-flex align-items-center justify-content-center">
                    <span>
                        <img className='img-fluid' src={require('../../../assets/img/icons/spinner.gif')} alt='Loader' />
                    </span>
                    <label>
                        Processing...
                    </label>
                </div>
                <div className="info">
                    Please wait while we redirect to your bank.
                    <span className='d-block'>
                        Please do not refresh the page or click back button of your browser.
                    </span>
                </div>
            </div>
        </div>
    );
}

export default PaymentProcess;